// FinancialPlanSection.js
import React from "react";
import "../../../css/components/FinancialPlanSection.css";
import SecondaryButton from "../../components/buttons/SecondaryButton";
import TertiaryButton from "../../components/buttons/TertiaryButton";
import { Link } from "react-router-dom";

const FinancialPlanSection = () => {
  return (
    <section className="financial-plan-container">
      <div className="financial-plan-container-content">
        <TertiaryButton
          children={
            <div className="subtitle uppercase secondary">
              Established 2025.
            </div>
          }
        />

        <h1>Build wealth. Protect what matters.</h1>
        <h1 className="secondary italic">Plan with confidence.</h1>
        <div className="subtitle grey">
          Life is unpredictable. Your financial plan shouldn’t be. We build
          robust, personalised plans that protect your family, grow your wealth,
          and adapt as your life changes.
        </div>
        <Link
          to="/#contact-us"
          className="nav-bold"
          style={{ textDecoration: "none" }}
        >
          <SecondaryButton text="Start the conversation" />
        </Link>
    
      </div>
    </section>
  );
};

export default FinancialPlanSection;
